
import { forwardRef } from 'react';
import Grid, { GridProps } from '@mui/material/Grid';

const Row = forwardRef<HTMLDivElement, GridProps>((props, ref) => (
  <Grid
    ref={ref}
    container
    {...props}
  />
));

Row.displayName = "Row";

export default Row;
